import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    standalone: false,
    name: 'parseDate'
})

export class ParseDatePipe implements PipeTransform {
    transform(date: string): any {
        if (date === '') {
            return '';
        }
        const dates = date.split('-');
        return new Date(parseFloat(dates[0]), parseFloat(dates[1]) - 1, parseFloat(dates[2]));
    }
}
